import { Product } from "~/entities/product/types";
import { SORTED_SIZES } from "~/entities/variant/constants";
import { SelectedVariant } from "~/entities/variant/types";

export function selectedVariantFrom(
  id: string | null,
  product: Product,
): SelectedVariant {
  const defaultSelectedVariant = (() => {
    const colorVariant = product.colors.find(
      (c) => c.color === product.defaultVariant.color,
    );

    if (!colorVariant) throw Error("Default variant color not found");

    return {
      ...colorVariant,
      ...product.defaultVariant,
    };
  })();

  if (!id) return defaultSelectedVariant;

  const variant = product.variants.find((variant) => variant.id === id);

  if (!variant) return defaultSelectedVariant;

  const colorVariant = product.colors.find((c) => c.color === variant.color);

  if (!colorVariant) return defaultSelectedVariant;

  return { ...variant, ...colorVariant };
}

export function sortBySize(a: { size: string }, b: { size: string }) {
  const sizeOrder = (item: { size: string }) => {
    return SORTED_SIZES.indexOf(item.size.toUpperCase());
  };
  return sizeOrder(a) - sizeOrder(b);
}
